<template>
  <div class="ras-about">
    <h2 class="ras-heading">How does the quiz work?</h2>
    <TextBlock :paras="paras" />
    <h3 class="ras-heading">Methodology</h3>
    <text-block :paras="methodology" :last="true" />
    <SiteFooter />
  </div>
</template>

<script>
import TextBlock from '@/components/Common/TextBlock.vue'
import SiteFooter from '@/components/Brand/Footer.vue'
export default {
  components: {
    TextBlock,
    SiteFooter
  },
  data: () => ({
    paras: [
      'We all love a good Netflix binge. We also all love a good vacation. So what would happen if we combined the two? We’ve created this quiz to choose your next destination based on your Netflix watching habits, basing the locations on key places in your favourite shows and films.',
      'With all the choices nowadays, it’s almost as hard to pick a vacation destination as it is to pick your next big binge. Luckily, this quiz will take all the thinking out of the decision. Pack your bags - a Netflix-inspired vacation is calling your name.'
    ],
    methodology: [
      '‘Whats on Netflix’ was used to get the top 100 most watched shows/movies on Netflix. The metrics that were used to figure out the top 3 locations for the user to go on holiday were:',
      `<ul>
        <li>Gender and Age ratings for each show/movie was from IMDB</li>
        <li>Genre for each movie/show was taken from IMDB and Netflix</li>
        <li>Information around the ‘how do you want to feel when watching’ was gathered from Netflix. E.g. the types of feelings the show evokes. The emotions to describe each show/movie were matched up with the 5 different feelings: Happy, Emotional, Scared, Apprehensive and Inspired.</li>
        <li>Vacation type</li>
        <li>Time of year to go on holiday</li>
      </ul>`,
      'The information gathered about each location:',
      `<ul>
        <li>Number of places (Booking.com) to stay based on a 2 mile radius from the location no less than 4 stars.</li>
        <li>Number of restaurants (Tripadvisor)</li>
        <li>Number of things to do (Tripadvisor)</li>
        <li>Average temperature of each season for each location</li>
      </ul>`
    ]
  })
}
</script>

<style lang="scss">
.ras-main {
  .ras-about {
    position: fixed;
    top: $m-header-height;
    height: calc(100vh - $m-header-height);
    padding: 40px;
    right: 0;
    z-index: 20;
    background: $c-hover;
    max-width: 640px;
    overflow-y: scroll;

    .ras-heading {
      text-align: center;
      margin-bottom: 20px;

      @media (min-width: map_get($breakpoints, lg)) {
        text-align: left;
      }
    }

    @media (min-width: map_get($breakpoints, lg)) {
      padding: 85px;
      top: $d-header-height;
      height: calc(100vh - $d-header-height);
    }

    @media (min-width: map_get($breakpoints, lg)) and (max-height: map_get($v-breakpoints, sm)) {
      top: $d-small-header-height;
      height: calc(100vh - $d-small-header-height);
    }

    ul {
      padding-left: 20px;
    }

    .ras-footer {
      position: relative;
      margin-top: 25px;
      bottom: 0;

      @media (min-width: map_get($breakpoints, lg)) {
        bottom: initial;
        top: 30px;
      }
    }
  }
}
</style>